<template>
  <div class="discount-rule-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "discountRuleBase",
};
</script>

